import React from "react";
import { useTranslation } from "react-i18next";
import SettingsHead from "../../components/settings-head/settings-head.component";
import { AIManagementContent } from "../../components/ai-management-content/ai-management-content.component";
import { CommonService } from "../../services/common/common.service";

export default function AIManagementPage() {
    const [t] = useTranslation();
    const commonService: CommonService = new CommonService();
    commonService.setTitle(t("ai data management"));

    return (
        <>
            <div className="role-contain">
                <div className="content">
                    <SettingsHead title={t('ai data management')} subTitle={t('extend and improve the ai engine')} />
                    <AIManagementContent />
                </div>
            </div>
        </>
    );
}